<template>
  <Modal class="modal modal--mob" v-if="popup.open" @click.self="closeModal">
        <template #header>
          <h2 v-if="popup.headline">
            {{ $t(popup.headline) }}
          </h2>
        </template>
        <template #body>
          <p v-if="popup.body" class="multiline" v-html="$t(popup.body)">
          </p>
        </template>
        <template #footer>
            <button @click="handle()" class="button button--primary w-100">
              {{ $t(popup.buttonText) }}
            </button>
        </template>
    </Modal>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import AuthenticatedMixin from "@/mixins/AuthenticatedMixin";
import {paymentFlowSource} from "@/service/payment/PaymentFlowSource";
import Modal from "@/components/generic/Modal";
export default {
  name: 'BuyCreditPopup',
  mixins: [AuthenticatedMixin],
  components: {Modal},
  computed: {
    ...mapState('buyCreditPopup', {
      popup: (s) => s
    })
  },
  methods: {
    ...mapActions('buyCreditPopup', ['close']),
    async handle() {
      paymentFlowSource.setItem(this.popup.props.gtm_purchase, this.auth.user)

      this.$router.push({name: 'credits'})

      await this.close()
    },
    closeModal() {
      if (this.popup.dismissible) this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
  p {
    line-height: 1.4;
    text-align: center;
  }
  .multiline {
    white-space: pre-line;
  }
</style>
